import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import bg_image from "@/assets/images/image_bg.jpg";
import gift from "@/assets/images/gift.jpg";
import wrap from "@/assets/images/wrap.jpg";
import gift2 from "@/assets/images/gift2.jpg";


const values = [
  {
    icon: "ri-heart-3-line",
    title: "Thoughtful Gifting",
    description: "Every product is carefully selected to ensure it brings joy and creates lasting memories.",
    color: "from-[#F78FB3] to-[#f5b8cc]",
  },
  {
    icon: "ri-leaf-line",
    title: "Sustainable Choices",
    description: "We partner with artisans and sustainable brands that care about our planet.",
    color: "from-[#3a8cbf] to-[#5ab0d4]",
  },
  {
    icon: "ri-medal-line",
    title: "Premium Quality",
    description: "Every item we curate passes our strict quality standards — no compromises.",
    color: "from-[#a8c8e8] to-[#f0a8c8]",
  },
];

const AboutPage = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [charCount, setCharCount] = useState(0);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    if (name === "message") {
      if (value.length > 500) return;
      setCharCount(value.length);
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <>
      <Navbar />
      <main className="bg-white">
        {/* Hero */}
        <section className="relative pt-20 lg:pt-24">
          <div
            className="h-64 lg:h-96 bg-cover bg-center relative"
            style={{
              backgroundImage:
                `url(${bg_image})`,
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60" />
            <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
              <span className="text-xs font-semibold tracking-[0.3em] uppercase text-white/70 mb-3">Our Story</span>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
                About Gift Mantra
              </h1>
            </div>
          </div>
        </section>

        {/* Brand Story */}
        <section className="py-20 lg:py-28 px-6 lg:px-10">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
              <div>
                <span className="text-xs font-semibold tracking-[0.3em] uppercase text-transparent bg-clip-text bg-gradient-to-r from-[#3a8cbf] to-[#e05a8a]">
                  Who We Are
                </span>
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mt-3 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
                  Gifting, Reimagined
                </h2>
                <p className="text-gray-600 leading-relaxed mb-5 text-base">
                  Gift Mantra was born from a simple belief — gifting should be as meaningful for the giver as it is for the receiver. We started as a small passion project, curating beautiful home decor and lifestyle products that tell a story.
                </p>
                <p className="text-gray-600 leading-relaxed mb-5 text-base">
                  Today, we're a destination for those who care about the art of gifting. Every product in our collection is handpicked by our team, ensuring it meets the Gift Mantra standard of beauty, quality, and thoughtfulness.
                </p>
                <p className="text-gray-600 leading-relaxed text-base">
                  From personalised keepsakes to luxurious hampers, we make sure your gift says exactly what you mean — without you needing to say a word.
                </p>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <img
                  src={gift}
                  alt="Gift wrapping"
                  className="w-full h-64 lg:h-80 object-cover rounded-2xl"
                />
                <div className="flex flex-col gap-4">
                  <img
                    src={wrap}
                    alt="Handmade crafts"
                    className="w-full h-36 lg:h-44 object-cover rounded-2xl"
                  />
                  <img
                    src={gift2}
                    alt="Premium gift box"
                    className="w-full h-36 lg:h-44 object-cover rounded-2xl"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Mission Quote */}
        <section className="py-16 lg:py-20 px-6 lg:px-10 bg-gradient-to-br from-[#f0f8ff] via-white to-[#fff0f5]">
          <div className="max-w-3xl mx-auto text-center">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-gradient-to-br from-[#5FA8D3]/10 to-[#F78FB3]/10 mx-auto mb-6">
              <i className="ri-double-quotes-l text-3xl text-transparent bg-clip-text bg-gradient-to-r from-[#3a8cbf] to-[#e05a8a]" />
            </div>
            <blockquote className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 leading-relaxed mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              Making gifting thoughtful, aesthetic, and unforgettable — one curated product at a time.
            </blockquote>
            <div className="w-16 h-0.5 bg-gradient-to-r from-[#3a8cbf] to-[#e05a8a] mx-auto rounded-full" />
          </div>
        </section>

        {/* Values */}
        <section className="py-20 lg:py-28 px-6 lg:px-10 bg-white">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-14">
              <span className="text-xs font-semibold tracking-[0.3em] uppercase text-transparent bg-clip-text bg-gradient-to-r from-[#3a8cbf] to-[#e05a8a]">
                What We Stand For
              </span>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mt-3" style={{ fontFamily: "'Playfair Display', serif" }}>
                Our Values
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {values.map((v, i) => (
                <div key={i} className="group text-center p-8 rounded-2xl border border-gray-100 hover:-translate-y-1 transition-all duration-300">
                  <div className={`w-16 h-16 flex items-center justify-center rounded-2xl bg-gradient-to-br ${v.color} mx-auto mb-5 group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${v.icon} text-white text-2xl`} />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {v.title}
                  </h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{v.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-16 px-6 lg:px-10 bg-gradient-to-r from-[#3a8cbf] to-[#e05a8a]">
          <div className="max-w-7xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-8 text-center">
            {[
              { value: "10,000+", label: "Happy Customers" },
              { value: "500+", label: "Curated Products" },
              { value: "50+", label: "Artisan Partners" },
              { value: "4.9★", label: "Average Rating" },
            ].map((stat, i) => (
              <div key={i}>
                <p className="text-3xl lg:text-4xl font-bold text-white mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {stat.value}
                </p>
                <p className="text-white/80 text-sm">{stat.label}</p>
              </div>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default AboutPage;
